import actions, { getWidth } from "./actions";
import { getView } from "../App/actions";
import {setErrorReducer, setRequestReducer, setSuccessReducer} from "../helper";
import {Helper} from "./helper";

const initState = {
    sessionReady: false, // true, false
    storeNotFound: false, // true, false
    storeOffline: false, // true, false
    pendingPayment: false, // true, false
    orderNotFound: false, // true, false

    view: getView(window.innerWidth), // MobileView, TabView, DesktopView
    gridSize: getWidth(window.innerWidth),
    width: window.innerWidth, // xs, sm, md, lg, xl, xxl

    readStoreState: false, // false, 'request', 'success', 'error'
    store: {
        friendlyName: '',
        logoUrl: '',
        email: '',
        phoneNo: '',
        url: '',
        addressText: '',
        street: '',
        city: '',
        state: '',
        postcode: '',
        countryCode: '',
        currencySymbol: '',
        bannerUrl: '',
    },

    readCategoriesState: false,
    categories: [], // { id: int, name: string }

    readFeaturedState: false,
    featured: [], // { categories: product [] (refer to state.Store.product) }

    readProductsInCategoryState: false,
    products: [], // product []  (refer to state.Store.product)
    pagination: {
        total: null,
        current: null,
        pageSize: null,
    },

    readProductDetailsState: false,
    product: {
        id: null,
        sku: null,
        name: null,
        description: null,
        salePrice: null,
        unitLabel: null,
        pictureUrl: null,
        isAvailable: false,
    },

    productData: [], // { same as product + lastUpdated: Date }
    shoppingCart: [], // { productId, name, qty, unitPrice, instructions, amount }
    shoppingCartSecret: Helper.generateSecret(),
    productsWithPriceChanges: [], // { productId, name, oldPrice, newPrice, oldUnitLabel, newUnitLabel }
    productsNotAvailable: [], // { productId, name }
    productsOutOfStock: [], // { productId, name }

    customerOrder: {
        customerName: '',
        customerMobile: '',
        customerEmail: '',
        instruction: '',
        deliveryStreet: '',
        deliveryCity: '',
        deliveryState: '',
        deliveryPostcode: '',
        deliveryCountryCode: '',
    },
    totals: {
        grandTotal: 0,
    },

    placeOrderState: false,
    paymentData: {
        token: undefined,
        customer_name: undefined,
        contact_number: undefined,
        email: undefined,
        reference_number: undefined,
        description: undefined,
        amount: undefined,
        return_url: undefined,
        callback_url: undefined,
    },

    readOrderDetailsState: false,
    order: {
        key: null,
    },

    productDrawerVisible: false,
    checkoutDrawerVisible: false,
    storeInfoDrawerVisible: false,
    checkoutConfirmationModalVisible: false,

    current: undefined,
    // eslint-disable-next-line
    emailsRegExp: /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])(\s*,\s*(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\]))*$/i,

};

function getInitState() {
    return {
        ...initState,
        ...Helper.readStorage(),
    };
}

let shoppingCart, idx, item;

export default function appReducer(state = getInitState(), action = {}) {
    switch (action.type) {
        // Read Store
        case actions.STORE_READ_STORE_REQUEST:
            return setRequestReducer(state, 'readStoreState');
        case actions.STORE_READ_STORE_SUCCESS:
            return setSuccessReducer(state, 'readStoreState', {
                store: action.store,
                categories: action.categories,
                sessionReady: true,
                storeNotFound: false,
                storeOffline: false,
            });
        case actions.STORE_READ_STORE_FAILURE:
            return setErrorReducer(state, 'readStoreState', {
                sessionReady: true,
                storeNotFound: true,
            });

        // Read Categories
        case actions.STORE_READ_CATEGORIES_REQUEST:
            return setRequestReducer(state, 'readCategoriesState');
        case actions.STORE_READ_CATEGORIES_SUCCESS:
            return setSuccessReducer(state, 'readCategoriesState', {
                categories: action.categories,
            });
        case actions.STORE_READ_CATEGORIES_FAILURE:
            return setErrorReducer(state, 'readCategoriesState');

        // Read Featured
        case actions.STORE_READ_FEATURED_REQUEST:
            return setRequestReducer(state, 'readFeaturedState');
        case actions.STORE_READ_FEATURED_SUCCESS:
            return setSuccessReducer(state, 'readFeaturedState', {
                featured: action.featured,
                productData: action.productData,
            });
        case actions.STORE_READ_FEATURED_FAILURE:
            return setErrorReducer(state, 'readFeaturedState');

        // Read Products in Category
        case actions.STORE_READ_PRODUCTS_IN_CATEGORY_REQUEST:
            return setRequestReducer(state, 'readProductsInCategoryState');
        case actions.STORE_READ_PRODUCTS_IN_CATEGORY_SUCCESS:
            return setSuccessReducer(state, 'readProductsInCategoryState', {
                products: action.products,
                productData: action.productData,
                pagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            });
        case actions.STORE_READ_PRODUCTS_IN_CATEGORY_FAILURE:
            return setErrorReducer(state, 'readProductsInCategoryState');

        // Read Product Details
        case actions.STORE_READ_PRODUCT_DETAILS_REQUEST:
            return setRequestReducer(state, 'readProductDetailsState', {
                product: initState.product,
            });
        case actions.STORE_READ_PRODUCT_DETAILS_SUCCESS:
            return setSuccessReducer(state, 'readProductDetailsState', {
                product: action.product,
            });
        case actions.STORE_READ_PRODUCT_DETAILS_FAILURE:
            return setErrorReducer(state, 'readProductDetailsState');

        // Shopping Cart
        case actions.STORE_ADD_ITEM_IN_CART:
        case actions.STORE_ADD_QTY_IN_CART:
        case actions.STORE_SUBTRACT_QTY_IN_CART:
        case actions.STORE_SET_QTY_IN_CART:
        case actions.STORE_SET_INSTRUCTION_IN_CART:
            shoppingCart = [...state.shoppingCart];

            idx = shoppingCart.findIndex(item => item.productId === action.productId);
            if (idx < 0) {
                // Add to Cart
                shoppingCart.push({
                    productId: action.productId,
                    name: '',
                    qty: action.qty || (action.addQty || action.subtractQty ? 0 : 1),
                    amount: undefined,
                    instruction: action.instruction || undefined,
                });
                idx = shoppingCart.length - 1;
            }
            item = {...shoppingCart[idx]};

            // Add Quantity
            if (action.addQty)
                item.qty += action.addQty;

            // Subtract Quantity
            if (action.subtractQty)
                item.qty -= action.subtractQty;

            // Set Quantity
            if (action.setQty)
                item.qty = action.setQty;

            // Set Instruction
            if (item.instruction !== action.instruction)
                item.instruction = action.instruction;

            // If quantity is zero => Remove
            if (item.qty <= 0)
                shoppingCart.splice(idx, 1);

            else
                shoppingCart[idx] = {...item};

            return Helper.writeToStorage({ ...state, shoppingCart});

        case actions.STORE_REMOVE_ITEM_IN_CART:
            shoppingCart = [...state.shoppingCart];
            idx = shoppingCart.findIndex(item => item.productId === action.productId);
            shoppingCart.splice(idx, 1);

            return Helper.writeToStorage({ ...state, shoppingCart });

        case actions.STORE_CLEAR_CART:
            return Helper.writeToStorage({
                ...state,
                shoppingCart: [],
                shoppingCartSecret: Helper.generateSecret(),
            });

        case actions.STORE_SET_CUSTOMER_ORDER_INFO:
            return Helper.writeToStorage({ ...state, customerOrder: action.customerOrder});

        case actions.STORE_READ_PRODUCT_DATA_SUCCESS:
            return { ...state, productData: action.productData };

        case actions.STORE_RECALCULATE_SUCCESS:
            return Helper.writeToStorage({
                ...state,
                shoppingCart: action.shoppingCart,
                productsWithPriceChanges: action.productsWithPriceChanges,
                productsNotAvailable: action.productsNotAvailable,
                productsOutOfStock: action.productsOutOfStock,
                totals: action.totals,
            });

        case actions.STORE_PLACE_ORDER_REQUEST:
            return setRequestReducer(state, 'placeOrderState');
        case actions.STORE_PLACE_ORDER_SUCCESS:
            return setSuccessReducer(state, 'placeOrderState', {
                paymentData: action.paymentData,
                pendingPayment: true,
                productDrawerVisible: false,
                checkoutDrawerVisible: false,
                storeInfoDrawerVisible: false,
            });
        case actions.STORE_PLACE_ORDER_FAILURE:
            return setErrorReducer(state, 'placeOrderState', {
                checkoutConfirmationModalVisible: false,
            });
        case actions.STORE_CLEAR_PAYMENT_DATA:
            return {...state, paymentData: {...initState.paymentData}, pendingPayment: false};

        case actions.STORE_GET_ORDER_DETAILS_REQUEST:
            return setRequestReducer(state, 'readOrderDetailsState');
        case actions.STORE_GET_ORDER_DETAILS_SUCCESS:
            return setSuccessReducer(state, 'readOrderDetailsState', {
                order: action.order,
            });
        case actions.STORE_GET_ORDER_DETAILS_FAILURE:
            return setErrorReducer(state, 'readOrderDetailsState', {
                orderNotFound: true,
            });

        case actions.STORE_TOGGLE_PRODUCT_DRAWER:
            return {...state, productDrawerVisible: action.value};
        case actions.STORE_TOGGLE_CHECKOUT_DRAWER:
            return {...state, checkoutDrawerVisible: action.value};
        case actions.STORE_TOGGLE_STORE_INFO_DRAWER:
            return {...state, storeInfoDrawerVisible: action.value};
        case actions.STORE_TOGGLE_CHECKOUT_CONFIRMATION_MODAL:
            return {...state, checkoutConfirmationModalVisible: action.value};
        case actions.STORE_CLOSE_NOTICE_MODAL:
            return {...state, productsWithPriceChanges: [], productsNotAvailable: [], productsOutOfStock: []};

        // Update Width
        case actions.STORE_UPDATE_WIDTH:
            return {
                ...state,
                view: action.view,
                gridSize: action.gridSize,
                width: action.width,
            };

        // set the current focsued key for sider
        case actions.STORE_CHANGE_CURRENT:
            return {...state, current: action.value};

        // Reset
        case actions.STORE_RESET:
            return {...initState};
        // Reset Products Array
        case actions.STORE_RESET_PRODUCTS:
            return {...state, products: initState.products};
        default:
            return state;
    }
}
